<template>
  <div class="teacherList">
    <div class="tips" v-if="!user.loginState">
      <!-- {{ $t('tip')
      }}<router-link
        :to="{ path: '/register', query: { type: 0 } }"
        class="ui-btn blue"
        >{{ $t('join') }}</router-link
      > -->
      <router-link
        :to="{ path: '/register', query: { type: 0 } }"
        class="ui-btn blue"
        >{{ $t('join') }}</router-link
      > 
      <a
        class="ui-btn"
        style="background: #d2474f;"
        href="https://api.whatsapp.com/send?phone=+85292607280"
        >{{ $t('common.advBtn') }}</a
      >
      <img
        class="adv-img"
        v-if="$i18n.locale === 'en'"
        style="width: 330px"
        src="../assets/teacherList_en.png"
        alt=""
      />
      <img
        class="adv-img"
        v-if="$i18n.locale === 'cn'"
        style="width:330px"
        src="../assets/teacherList_cn.png"
        alt=""
      />
      <img
        class="adv-img"
        v-if="$i18n.locale === 'TW'"
        style="width:330px"
        src="../assets/teacherList_tw.png"
        alt=""
      />
    </div>
    <div class="head">
      <h2 class="title">{{ user.loginState ? $t('choose') : $t('nav2') }}</h2>
      <div class="filter">
        <span class="lab">{{ $t('common.course') }}{{ $t('colon') }}</span>
        <a
          class="cell"
          :class="{ on: info.courseId === 0 }"
          @click="changeTab(0)"
          >{{ $t('nolimit') }}</a
        >
        <a
          class="cell"
          :class="{ on: info.courseId === 1 }"
          @click="changeTab(1)"
          >A-Level</a
        >
        <a
          class="cell"
          :class="{ on: info.courseId === 2 }"
          @click="changeTab(2)"
          >IB</a
        >
      </div>
    </div>
    <ul class="lists">
      <li v-for="item in list" :key="item.teacherId">
        <card
          :info="item"
          :showOrder="user.state === 10 && user.state !== 0"
        ></card>
      </li>
    </ul>
    <el-pagination
      class="ui-pagination"
      @current-change="changePage"
      background
      layout="prev, pager, next"
      :total="info.totalCount"
    ></el-pagination>
    <platform></platform>
  </div>
</template>
<script>
import platform from '@/components/Platform.vue'
import card from '@/components/TeacherCard.vue'
import { getTeacherList } from '@/service/teacherApi.js'
// import { delete } from 'vue/types/umd'
export default {
  name: 'teacherList',
  components: { platform, card },
  data() {
    return {
      info: {
        courseId: 0,
        pageNO: 1,
        pageSize: 10,
        isRecommend: 1,
        totalCount: 0,
      },
      list: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      if (this.user.loginState && this.user.userType === 10) {
        this.info.isRecommend = -1
      }
      const param=JSON.parse(JSON.stringify(this.info))
      param.totalCount=null;
      let res = await getTeacherList(param)
      
      if (res.data.status === 1) {
        this.list = res.data.data
        this.info.totalCount = res.data.totalCount
      }
    },
    changeTab(n) {
      this.info.courseId = n
      this.info.pageNO = 1
      this.getList()
    },
    goOrder(id) {
      if (this.user.loginState) {
        this.$router.push({ path: '/teachers/appointment', query: { id: id } })
      } else {
        this.$router.push({ path: '/login' })
      }
    },
    changePage(val) {
      this.info.pageNO = val
      this.getList()
    },
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
}
</script>
<style lang="scss" scoped>
.teacherList {
  background: #fff;
}
.ui-pagination {
  margin-bottom: 90px;
}
.head {
  background: #fff;
  padding: 20px 0 0;
  box-shadow: 0 6px 14px rgba($color: #000, $alpha: 0.05);
}
.title {
  color: #002147;
  text-align: center;
  font-size: 36px;
}
.filter {
  width: 1200px;
  margin: 20px auto 0;
  border-top: 1px solid #dbdbdb;
  padding: 33px 0 42px;
  text-align: center;
  line-height: 42px;
  .lab {
    font-size: 18px;
    margin-right: 45px;
  }
  .cell {
    display: inline-block;
    min-width: 140px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    color: #555;
    font-size: 18px;
    margin-right: 20px;
    border-radius: 42px;
    &:hover {
      color: #002147;
    }
    &.on {
      background: #002147;
      color: #fff;
      font-size: 16px;
    }
  }
}
.lists {
  margin: 40px auto 0;
  width: 1200px;
  li {
    background: #fff;
    border-radius: 3px;
    box-shadow: 0 6px 12px rgba($color: #000000, $alpha: 0.05);
    margin-bottom: 20px;
  }
}
.teacherCard {
  overflow: hidden;
  padding: 30px;
}
.avatar {
  float: left;
  width: 320px;
  height: 320px;
  position: relative;
  font-size: 0;
  margin-right: 50px;
  img {
    width: 100%;
    height: 100%;
  }
}
.tip {
  position: absolute;
  top: -12px;
  right: -15px;
  width: 111px;
  height: 111px;
  background: url(../assets/triangle2.png);
  text-align: center;
  .txt {
    display: inline-block;
    font-size: 21px;
    transform: rotate(45deg);
    color: #fff;
    transform-origin: 0 141%;
  }
}
.btns {
  float: right;
  width: 236px;
  padding: 26px 0 0 30px;
  text-align: left;
  margin-top: 33px;
  height: 267px;
  border-left: 1px solid #dcdcdc;
  text-align: center;
  .ui-btn {
    margin-top: 12px;
  }
}
.info {
  padding-top: 20px;
  overflow: hidden;
  p {
    margin-bottom: 10px;
    font-size: 18px;
    color: #555;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .name {
    font-size: 36px;
    color: #002147;
    line-height: 64px;
    margin-bottom: 30px;
    .txt {
      display: inline-block;
      max-width: 420px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      vertical-align: top;
    }
  }
  .lab {
    color: #000;
  }
}
.tag {
  display: inline-block;
  margin-left: 30px;
  padding: 0 16px;
  height: 24px;
  line-height: 24px;
  border-radius: 24px;
  background: #a9c4b1;
  color: #fff;
  font-size: 14px;
}
.tips {
  width: 1000px;
  margin: 0 auto;
  // padding: 30px;
  font-size: 16px;
  line-height: 2;
  border: 1px solid #eee;
  background: #fafafa;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 5;
  text-align: center;
  .ui-btn {
    left:50%;
    width: 180px;
    // max-width: 140px;
    margin-left: -90px;
    position: absolute;
    top: 138px;
  }
  .ui-btn:nth-child(2){
    top:256px;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .filter .lab {
    margin: 0;
    font-size: 16px;
  }
  .filter .cell {
    font-size: 16px;
    min-width: initial;
    width: auto;
    margin-right: 0;
    border-radius: 15px;
  }
  .tips {
    width: 100%;
    padding: 5px 20px;
    word-break: normal;
    line-height: normal;
    a {
      // display: none;
    }
  }
  .filter,
  .lists {
    width: 100%;
  }
  .platform {
    padding: 0;
  }
  .filter {
    padding: 20px 10px;
    .lab {
      margin-left: 0;
    }
    .cell {
      padding: 0 20px;
      border-radius: 20px;
    }
  }
}
</style>
<i18n>
{
  "cn": {
    "choose": "选择老师",
    "nolimit": "不限",
    "tip": "如要查看我们完整的导师名单，请先注册一个学生帐号。一旦您的帐号成功通过审核，您即可与我们所有世界级导师约课，并以即时信息联系。我们所有的导师都拥有牛津或剑桥大学的学术背景，包括：教授、讲师、博士后和研究生，您可以从中选择适合您的导师。",
    "join": "请即加入我们！"
  },
  "TW": {
    "choose": "选择老师",
    "nolimit": "不限",
    "tip": "如要查看我們完整的導師名單，請先註冊一個學生帳號。一旦您的帳號成功通過審核，您即可與我們所有世界級導師約課，並以即時資訊聯系。我們所有的導師都擁有牛津或劍橋大學的學術背景，包括：教授、講師、博士後和研究生，您可以從中選擇適合您的導師。",
    "join": "請即加入我們"
  },
  "en": {
    "choose": "Choose your Tutor",
    "nolimit": "Any",
    "tip": "To view our full list of world-class Tutors, please first register a student account with us. Once your account is approved, you can enjoy full access (including direct messaging) to Tutors with a wealth of unrivalled academic talent, including professors and lecturers, all with academic backgrounds from Oxford and Cambridge.",
    "join": "Join us now! "
  }
}
</i18n>